import { VendorDetailPage } from '@/features/vendor/pages/VendorDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/vendor/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["vendor.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: VendorDetailPage,
})
